var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4240_3956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5965 1.75235C15.4261 1.58197 15.2134 1.46006 14.9803 1.39919C14.7472 1.33833 14.5021 1.34069 14.2702 1.40605L14.2553 1.4108L1.24968 5.35362C0.985514 5.43021 0.750901 5.58536 0.577005 5.79846C0.403108 6.01156 0.298159 6.27251 0.276097 6.54667C0.254035 6.82083 0.315904 7.09522 0.453486 7.33338C0.591069 7.57154 0.797853 7.76221 1.04637 7.88006L6.76069 10.5908L9.47146 16.3052C9.57967 16.5373 9.75201 16.7336 9.96815 16.871C10.1843 17.0083 10.4352 17.081 10.6913 17.0804C10.7299 17.0804 10.7692 17.0804 10.8086 17.0757C11.0825 17.0539 11.3431 16.9485 11.5553 16.7739C11.7675 16.5993 11.9211 16.3638 11.9952 16.0991L15.938 3.09351C15.94 3.08868 15.9416 3.08369 15.9428 3.0786C16.0081 2.84671 16.0105 2.60159 15.9496 2.36847C15.8888 2.13536 15.7668 1.92269 15.5965 1.75235ZM10.6398 14.9714L8.35462 10.1469L11.4212 7.08038C11.574 6.92761 11.6598 6.7204 11.6598 6.50434C11.6598 6.28829 11.574 6.08108 11.4212 5.9283C11.2684 5.77553 11.0612 5.6897 10.8451 5.6897C10.6291 5.6897 10.4219 5.77553 10.2691 5.9283L7.20254 8.99487L2.37736 6.70901L14.2316 3.11723L10.6398 14.9714Z",
    fill: "#CED4DA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4240_3956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.349,
    height: 17.349,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSend);
export default __webpack_public_path__ + "static/media/icon-send.25230a8f1c8d2f6dda5c92a75b517725.svg";
export { ForwardRef as ReactComponent };